import { render, staticRenderFns } from "./MemberRegistComplete.vue?vue&type=template&id=2e9fd0ea&scoped=true&"
import script from "./MemberRegistComplete.vue?vue&type=script&lang=js&"
export * from "./MemberRegistComplete.vue?vue&type=script&lang=js&"
import style0 from "./MemberRegistComplete.vue?vue&type=style&index=0&id=2e9fd0ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9fd0ea",
  null
  
)

export default component.exports